export interface RunDisplayNameKeyParts {
  entityName: string;
  projectName: string;
  runName: string;
}
export function createRunDisplayNameKey(parts: RunDisplayNameKeyParts): string {
  return `${parts.entityName}/${parts.projectName}/${parts.runName}`;
}
